import { useContext, useMemo } from "react";
import VenuesContext, { Venue } from "../../../contexts/VenuesContext";

export type SchoolOption = {
  name: string;
  serviceId: string;
  suburb: string;
  postcode: string;
};

const LIVE_STATUSES = ["Live", "New", "Active"];

// Projects the build-time venue list (VenuesContext) into picker options. No runtime fetch.
const useSchoolOptions = (): SchoolOption[] => {
  const venues = useContext(VenuesContext);

  return useMemo(
    () =>
      (venues || [])
        .filter((venue: Venue) => LIVE_STATUSES.includes(venue?.status))
        .map((venue: Venue) => ({
          name: venue.name,
          // Kidsoft ID (UUID) is HubSpot's service_id; incremental id is a fallback.
          serviceId: venue.kidsoftId || venue.id,
          suburb: venue.address?.townCity ?? "",
          postcode: venue.address?.postcode ?? "",
        }))
        .filter((option: SchoolOption) => option.name),
    [venues],
  );
};

export default useSchoolOptions;
